var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-radio",class:{'z-chk': _vm.checkState, 'z-dis': _vm.disabled},on:{"click":function($event){return _vm.checkHandle(true, true)}}},[_c('div'),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }